export default {
      id: "help__settings_icon-usage",
      viewBox: "0 0 45 45",
      url: __webpack_public_path__ + "img/icons.svg#help__settings_icon",
      toString: function () {
        return this.url;
      }
    }